import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useNavigate } from 'libs/router'
import { useTranslation } from 'libs/i18n'
import { queryKeys } from 'config/queryKeys'

export const useCreateRentalMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const { mutate: createRental, isPending: createRentalLoading } = useMutation({
		mutationFn: (data) => {
			// TODO: change to apiRoutes
			return axiosPrivate.post('/rentals/', data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.rentals.all })
			useToast({ type: 'success', message: t('Rental created') })()

			// TODO: change to routes
			navigate('/rentals')
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createRental,
		createRentalLoading
	}
}
